const styles = theme => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 0,
    margin: 0,
  },
  root: {
    height: '100vh',
  },
  title: { margin: theme.spacing(4, 0, 2), [theme.breakpoints.down('sm')]: { margin: theme.spacing(6, 0, 4) } },
  image: {
    backgroundImage: `url(${theme.coverImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: theme.palette.primary.main,
  },
  paper: {
    padding: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(6, 4, 0),
      borderRadius: 0,
      borderTop: `8px solid ${theme.palette.primary.main}`,
    },
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 0),
    color: '#fff',
  },
  button: {
    color: '#fff',
    marginTop: theme.spacing(2),
  },
  passwords: {
    marginTop: theme.spacing(2),
  },
  errorHelper: { marginTop: 0, color: '#fff' },
  errorMessage: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    padding: theme.spacing(2, 2),
    backgroundColor: theme.palette.error.light,
  },
  passwordReset: {
    display: 'flex',
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    justifyContent: 'center',
    padding: theme.spacing(2, 2),
    margin: theme.spacing(2, 0),
  },
  paragraph: { margin: theme.spacing(0, 0, 2), textAlign: 'left' },
  passwordResetMessage: {
    marginTop: 0,
    color: '#fff',
  },
})

export default styles
